import { useClientSelector } from 'client/reducers';
import { selectStoryLang } from 'client/reducers/story/selectors';
import { DEFAULT_LANGUAGE } from '../constants';
import type { SupportedLanguage, StoryDictionary } from '../types';
import { dictionaryCache, createDictionaryKeyResolverFn, isRTLLanguage } from '../utils';

// hook implementation for functional component usage
export const useClientStoryDictionary = (): StoryDictionary => {
	const language = useClientSelector(selectStoryLang);
	return getClientStoryDictionary(language);
};

// functional implementation for class component usage
export const getClientStoryDictionary = (_language: SupportedLanguage | undefined): StoryDictionary => {
	const language = _language || DEFAULT_LANGUAGE;
	const dictionary = dictionaryCache.get(language) || null;
	const t = createDictionaryKeyResolverFn(dictionary);

	return {
		isRTL: isRTLLanguage(language),
		language,
		dictionary,
		t,
	};
};
